import React from 'react'


const Drawer = props => {

	const {
		children,
		closeDrawer,
		direction,
		isOpen
	} = props

	let isOpenClass = isOpen ? '_open' : '_close'

	return (
		<>
			<button
				className={`drawerOverlay ${isOpenClass}`}
				onClick={closeDrawer}
			></button>
			<div className={`drawer ${direction} ${isOpenClass}`}
				onClick={closeDrawer}
			>
				{children}
			</div>
		</>
	)

}


export default Drawer
